export default __webpack_public_path__ + "static/media/portfolio-45.1bd56f76.jpg";